/* Smartparts24 · AGB-Haken auf der Produktseite ausblenden (gilt nur noch im Warenkorb), Header-Button auf Kontakt */
(function () {
  'use strict';
  var d = document;
  var SEL = 'product-info .m-terms-conditons, .m-product-form .m-terms-conditons, .main-product .m-terms-conditons';

  function terms() {
    d.querySelectorAll(SEL).forEach(function (w) {
      var i = w.querySelector('input[type="checkbox"]');
      if (i && !i.checked) {
        i.checked = true;
        i.dispatchEvent(new Event('change', { bubbles: true }));
      }
      w.setAttribute('hidden', '');
    });
  }

  function headerCta() {
    var a = d.querySelector('.sp24-header-cta');
    if (a && /wa\.me/.test(a.getAttribute('href') || '')) {
      a.setAttribute('href', '/pages/kontakt');
      a.removeAttribute('rel');
      a.textContent = 'Kontakt';
    }
  }

  function run() { terms(); headerCta(); }

  function init() {
    run();
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); }).observe(d.body, { childList: true, subtree: true });
    }
  }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
